import { useTranslation } from "react-i18next";
import InfoFlyUpModal from "../../../InfoFlyUpModal";
import InfoModal from "../../../InfoFlyUpModal/components/InfoModal";

export interface BMIModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export default function BMIModal({ isOpen, onClose }: BMIModalProps = {}) {
  const { t } = useTranslation();

  const modalProps = {
    title: t("HealthHistory.bmi.modal.title"),
    description: t("HealthHistory.bmi.modal.description"),
    importanceTitle: t("HealthHistory.bmi.modal.importanceTitle"),
    textList: t("HealthHistory.bmi.modal.list", {
      returnObjects: true,
    }) as string[],
  };

  if (isOpen !== undefined && onClose !== undefined) {
    return (
      <InfoModal
        isOpen={isOpen}
        handleClose={onClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        textList={modalProps.textList}
      />
    );
  }

  return (
    <InfoFlyUpModal
      cardProps={{
        title: t("HealthHistory.bmi.modal.card.title"),
        description: t("HealthHistory.bmi.modal.card.description"),
      }}
      modalProps={modalProps}
    />
  );
}
